import { Box, Button, Layer, Text } from "grommet";
import React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../Hooks/useStore";
import { Auth } from "aws-amplify";
import { Mixpanel } from "../Helper";
import "./InfoPopUp.css";
import { unsubscribeToTopic } from "../../App";

function UserRestrictLoginModal() {
  const { rootStore } = useStore();

  // yes button handler
  const onYesBtnClick = async () => {
    try {
      let username;
      // get user info
      let userInfo = localStorage.getItem("userinfo");
      console.log("userInfo in logoutSession", userInfo);
      if (userInfo) {
        username = JSON.parse(userInfo)?.username;
      }
      console.log("username logoutSession", username);
      Auth.signOut();
      unsubscribeToTopic(rootStore);
      if (username) {
        Mixpanel.track("web_user_logout", { name: username });
      }
      Mixpanel.resetUser();
      localStorage.clear();
    } catch (error) {
      console.log(error);
    }
  };
  setTimeout(() => {
    onYesBtnClick();
  }, 1000);

  const redirectToLogin = () => {
    rootStore.userStore.handleUserRestModal(false);
    window.location.replace("/");
  };

  const styles = {
    container: {
      overflow: "hidden",
      width: 600,
      paddingBottom: 30,
    },
    header: {
      padding: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px 12px 0px 0px",
      background: "#E9F2FF",
      color: "#4B628A",
      fontFamily: "Inter",
      fontSize: 20,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "26px",
    },
    content: {
      padding: 30,
      textAlign: "center",
      color: "#4B628A",
      fontFamily: "Inter",
      fontSize: 16,
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "22px",
    },
    btn: {
      padding: "14px 49px",
      backgroundColor: "#357EFF",
      color: "#fff",
      borderRadius: 10,
    },
  };

  return (
    <Layer style={{ borderRadius: "12px" }}>
      <Box style={styles.container}>
        <Box style={styles.header}>Invalid Login Credentials</Box>
        <Text style={styles.content}>EMS and Admin is allow to login.</Text>
        <Box direction="row" align="center" justify="center">
        <Button
            className="btn"
            style={styles.btn}
            label="Cancel"
            onClick={redirectToLogin}
        />
        </Box>
      </Box>
    </Layer>
  );
}

export default observer(UserRestrictLoginModal);
